import { BaseApi } from '@/core/api/base.api'
import { Room } from "@/core/api/room.api";
import { roomInfoService } from "@/core/service/room.info.service";
import { i18n } from "@/locales/i18n"
import _ from 'lodash'


class RoomInfoApi extends BaseApi {
  #roomInfo

  constructor() {
    super();
  }

  #Events = {}

  async setRoomInfo(roomId) {
    let info = await roomInfoService.getRoomInfo(roomId);
    await this.setLocaleMsg(i18n.locale, info)
    this.#roomInfo = info.data && info.data.roomInfoModule;
    
    let data = { roomInfo: this.#roomInfo };
    Room.addRoomData(data)
    return  _.cloneDeep(data)
  }
  
  async getLocaleMessage(locale) {
    let message = await import(`@/locales/message/${locale}.json`);
    return message;
  }

  getRoomInfo(){
    return this.#roomInfo
  }
  getRoomSettings () {
    return this.#roomInfo?.setting || {}
  }
  useModule (moduleName) {
    const settings = this.getRoomSettings();
    if(!moduleName.startsWith('use')){
      moduleName = 'use'
        + moduleName.substring(0, 1).toUpperCase()
        + moduleName.substring(1)
    }
    return settings[moduleName] !== false;
  }

  useScreenMerger(){
    return this.#roomInfo?.setting?.useScreenMerger;
  }
  defaultRoleCamera(){
    return this.#roomInfo?.setting?.defaultRoleCamera;
  }
  defaultRoleMic(){
    return this.#roomInfo?.setting?.defaultRoleMic;
  }
  useLmsAbsentees(){
    return this.#roomInfo?.setting?.useLmsAbsentees;
  }
  
  async setLocaleMsg(locale, roomInfo){
    const serverMsg = roomInfo.data?.roomInfoModule?.msg || roomInfo?.msg
    if (!serverMsg) {
      return
    }
    let message = await this.getLocaleMessage(locale);
    _.merge(message, serverMsg[locale])
  }
}

export const RoomInfo = new RoomInfoApi();
